<template>
  <div class="ax-phone-number">
    <template v-if="isHydrated">
      <vue-tel-input
        v-model="model"
        :class="{ error: !isValid }"
        :disabledFetchingCountry="disableAutomatedCountry"
        :dropdownOptions="dropdownOptions"
        dynamicPlaceholder
        enabledCountryCode
        enabledFlags
        :inputOptions="inputOptions"
        :maxLen="maxLength"
        :preferredCountries="preferredCountries"
        validCharactersOnly
        @country-changed="handleCountryChanged"
        @validate="handleValidate"
        ref="phone-input"
      />
      <input
        v-if="useHiddenInput"
        :id="inputId"
        :name="inputName"
        :value="isValid ? formattedValue : ''"
        type="hidden"
      />
    </template>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'

const defaultDropdownOptions = { disabledDialCode: false, tabindex: -1 }
const defaultInputOptions = { showDialCode: false, tabindex: 0 }
const defaultPreferredCountries = ['US', 'CA']
const defaultMaxLength = 20
// const defaultCountries = [...defaultPreferredCountries, 'UK', 'AUS'];

// US/CA validation regex: ^\+\d{1,3} \(\d{3}\) \d{3}-\d{4}(\+\d{1,4})?$

export default {
  name: 'form-phone-number',
  components: { VueTelInput },
  props: {
    /**
     * See vue-tel-input prop `onlyCountries` for keys and values
     * @DOC https://educationlink.github.io/vue-tel-input/documentation/v3.html#props
     */
    // countries: {
    //   type: Array,
    //   default: () => defaultCountries,
    // },
    /**
     * See vue-tel-input prop `dropdownOptions` for keys and values
     * @DOC https://educationlink.github.io/vue-tel-input/documentation/v3.html#props
     */
    dropdownOptions: {
      type: Object,
      default: () => defaultDropdownOptions,
    },
    emitFormattedValue: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
    },
    inputName: {
      type: String,
    },
    /**
     * See vue-tel-input prop `inputOptions` for keys and values
     * @DOC https://educationlink.github.io/vue-tel-input/documentation/v3.html#props
     */
    inputOptions: {
      type: Object,
      default: () => defaultInputOptions,
    },
    /**
     * See vue-tel-input prop `preferredCountries` for keys and values
     * @DOC https://educationlink.github.io/vue-tel-input/documentation/v3.html#props
     */
    preferredCountries: {
      type: Array,
      default: () => defaultPreferredCountries,
    },
    useHiddenInput: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countryCode: null,
      disableAutomatedCountry: false,
      isHydrated: false,
      isValid: false,
      maxLength: defaultMaxLength,
      phoneNumberValue: '',
      testValue: '',
    }
  },
  mounted() {
    this.initialHydration()
  },
  computed: {
    formattedValue() {
      return this.formatValue(this.model)
    },
    model: {
      get() {
        return this.phoneNumberValue
      },
      set(value) {
        this.phoneNumberValue = value
        this.$emit('input', this.emitFormattedValue ? this.formatValue(value) : value)
      },
    },
  },
  methods: {
    formatValue(value) {
      if (!value) {
        return ''
      }

      let output = value || ''
      if (output.startsWith('+')) {
        const regex = /^\+\d{1,4}/gm
        output = value.replace(regex, '')
      }
      return `+${this.countryCode} ${output}`
    },
    handleCountryChanged(event) {
      this.countryCode = event.dialCode
    },
    handleValidate(event) {
      this.isValid = true
      this.$emit('validate', true) // if we don't pass true then the entered number isn't posted to the Reister endpoint when it's invalid (and the validation isn't reliable)
    },
    initialHydration() {
      if (this.value) {
        const regex = /^(\+\d{1,4} )(.+)$/gm

        const matchingGroups = regex.exec(this.value)
        if (matchingGroups && matchingGroups.length === 3) {
          if (matchingGroups[1]) {
            this.countryCode = matchingGroups[1].replace('+', '').trim()
            this.disableAutomatedCountry = true
          }
        }
        this.phoneNumberValue = this.value
      }
      this.$emit('input', this.phoneNumberValue)
      this.isHydrated = true
    },
  },
}
</script>
